var crypto = require('crypto'),
  algorithm = 'aes-256-gcm';

/**
 * Encrypt data
 * @param {*} hashPassword 32 bytes input
 * @param {*} text content encrypted
 */
function encrypt(hashPassword, text) {
  const iv = crypto.randomBytes(16).toString('hex');
  var cipher = crypto.createCipheriv(algorithm, hashPassword, iv);
  var encrypted = cipher.update(text, 'utf8', 'hex');
  encrypted += cipher.final('hex');
  var tag = cipher.getAuthTag();
  return JSON.stringify({
    content: encrypted,
    tag: JSON.stringify(tag),
    iv
  });
}

/**
 * Decrypt data
 * @param {*} hashPassword 32 bytes input
 * @param {*} dataEncrypted data after encrypted
 */
function decrypt(hashPassword, dataEncrypted) {
  const payload = JSON.parse(dataEncrypted);
  var decipher = crypto.createDecipheriv(algorithm, hashPassword, payload.iv);
  decipher.setAuthTag(Buffer.from(JSON.parse(payload.tag).data));
  var dec = decipher.update(payload.content, 'hex', 'utf8');
  dec += decipher.final('utf8');
  return dec;
}

/**
 * Hash data with md5
 * @param {*} text text hash
 */
function md5(text) {
  return crypto
    .createHash('md5')
    .update(text)
    .digest('hex');
}

export { encrypt, decrypt, md5 };
